<template>
  <div class="bask-page">
    <div class="bg">
      <div class="player-select">
        <div class="left" v-if="componentName == 'VolleyballSchedule'">
          <!-- <template v-if="agencyList.length > 0"> -->
          <a-select class="select" @change="handleRank" placeholder="选择轮次" size="large">
            <a-select-option :value="item" v-for="(item, index) in agencyList" :key="item">
              第{{ item }}轮
            </a-select-option>
          </a-select>
          <!-- </template> -->
          <a-select class="select" @change="handleTeam" placeholder="选择球队" size="large">
            <a-select-option :value="999" key="999">
              所有球队
            </a-select-option>
            <a-select-option :value="item.joinerId" v-for="(item, index) in TeamList" :key="index">
              {{ item.abbreviation }}
            </a-select-option>
          </a-select>
        </div>
        <div class="left" v-if="componentName == 'VolleyballRank'">
          <a-select default-value="赛段" class="select" @change="handleChange(1)" placeholder="赛段" size="large">
            <a-select-option value="赛段">
              赛段1
            </a-select-option>
            <a-select-option value="赛段2">
              赛段2
            </a-select-option>
          </a-select>
          <a-select default-value="轮次" class="select" @change="handleChange(2)" placeholder="轮次" size="large">
            <a-select-option value="轮次">
              轮次
            </a-select-option>
            <a-select-option value="lucy">
              轮次
            </a-select-option>
          </a-select>
        </div>

        <div class="left" v-if="componentName == 'VolleyballPlayer'">
          <a-select  class="select" @change="handleSex" placeholder="选择性别" size="large">
            <a-select-option :value="-1">
              不限
            </a-select-option>
            <a-select-option :value="1">
              男
            </a-select-option>
            <a-select-option :value="2">
              女
            </a-select-option>
          </a-select>
          <a-select class="select" @change="handleTeam" placeholder="选择球队" size="large">
            <a-select-option :value="999" key="999">
              所有球队
            </a-select-option>
            <a-select-option :value="item.joinerId" v-for="(item, index) in TeamList" :key="index">
              {{ item.abbreviation }}
            </a-select-option>
          </a-select>
        </div>

        <div class="right">
          <div class="next-last" v-if="componentName == 'VolleyballSchedule' || componentName == 'VolleyballRank'">
            <div class="back" @click="handleBack">
              <a-icon type="left" style="margin-left:-5px" />
              <span>上一轮</span>
            </div>
            <div class="next" @click="handleNext">
              <span>下一轮</span>
              <a-icon type="right" style="margin-right:-5px" />
            </div>
          </div>
          <div class="player-total" v-if="componentName == 'VolleyballPlayer'">共计 {{ total }} 名参赛运动员</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VolleyballPlayer',
  props: {
    componentName: {
      type: String,
      default: 'VolleyballPlayer',
    },
    playerList: {
      type: Array,
      default: () => [],
    },
    total:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      agencyList: [],
      TeamList: [],
      rank: 1,
      team: null,
      matchId: this.$route.query.matchId,
    }
  },
  components: {},
  mounted() {
    this.getAllTeam()
    this.getQueryBigballPkRank()
    this.matchId=1323

  },
  methods: {
    //index:1为轮次，2为球队，3性别 
    //上一轮
    handleBack() {
      if (this.rank > 1) {
        this.rank--
        this.$emit('handleSelect', this.rank, 1)
      }
    },
    //下一轮
    handleNext() {
      if (this.rank < this.agencyList.length) {
        this.rank++

        this.$emit('handleSelect', this.rank, 1)
      }
    },
    //选择轮次
    handleRank(e) {
      if (e == 999) {
        this.rank = null
      } else {
        this.rank = e
      }
      this.$emit('handleSelect', this.rank, 1)
    },
    //选择球队
    handleTeam(e) {
      if (e == 999) {
        this.team = null
      } else {
        this.team = e
      }
      this.$emit('handleSelect', this.team, 2)
    },
    //选择性别
    handleSex(sex) {
      this.$emit('handleSelect', sex, 3)
    },
    //获取所有球队
    getAllTeam() {
      this.$api.match
        .queryJoinAgencyData({ matchId: this.matchId })
        .then((res) => {
          if (res.status === 0) {
            this.TeamList = res.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //获取排球轮次
    async getQueryBigballPkRank() {
      let data = {
        agencyId: this.agencyId,
        matchId:this.matchId
      }
      try {
        let res = await this.$api.district.queryBigballPkRank(data)
        if (res.status == 0) {
          this.agencyList = res.data
        } else {
          this.message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.bask-page {
  width: 100%;
  .bg {
    width: 100%;
    background-color: #f7f7f7;
    //   background-color: rgba(67, 67, 67,0.8);
    padding: 20px 0;
    .select {
      width: 160px;
      margin-right: 10px;
    }
    .player-select {
      width: 1200px;
      margin: 0 auto;
      height: 70px;
      background-color: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      flex-wrap: nowrap;
      align-items: center;
      padding: 0 30px;
      box-sizing: border-box;
      box-shadow: 0px 5px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        justify-content: flex-start;
      }
      .right {
        width: 300px;
        display: flex;
        justify-content: flex-end;
        .player-total {
          color: #999;
          font-style: 14px;
        }
        .next-last {
          width: 220px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          div {
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #d3d3d3;
            font-weight: bold;
            cursor: pointer;
          }
          .div:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballSelect.vue